export const FileTypeMap: { [key: string]: string } = {
    'md': 'markdown'
};

export interface IFilenameParts {
    name: string;
    ext: string;
}
export const getFileParts = (filename: string):IFilenameParts => {
    const nameParts = filename.split('.')
    let fileType = '';
    let name = filename;
    if (nameParts.length>1) {
        fileType = nameParts[nameParts.length-1]
        name = filename.substring(0, filename.lastIndexOf(fileType))
    }
    return {
        name: name,
        ext: fileType
    }

}
